import PropTypes from "prop-types";
import { useRef, useState } from "react";

import { Button } from "@mui/material";

const CategoryTabs = ({
  tabs = [],
  selectedTab = [],
  onClearAll,
  onTabChange,
  showCount = false,
  className = "",
  title = "Category",
}) => {
  const [hoveredKey, setHoveredKey] = useState(null);
    const scrollRef = useRef(null);
  if (!tabs.length) return null;
  return (

    <div
      role="tablist"
      aria-label="Category tabs"
      className={className}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "nowrap",
        overflowX: "auto",
        gap: "8px",
        padding: "13px 16px",
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: "10px",
        scrollbarWidth: "thin",
        scrollbarColor: "#c1c1c1 #e0e0e0",
      }}
    >
      <span
        style={{
          fontSize: "14px",
          fontWeight: 600,
          whiteSpace: "nowrap",
          flexShrink: 0,
          marginRight: "4px",
        }}
      >
        {title} :
      </span>
<div
        ref={scrollRef}
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "8px",
          flex: 1,
          overflowX: "auto",
          padding: "6px 12px",
          scrollbarWidth: "thin",
          scrollbarColor: "#c1c1c1 #e0e0e0",
        }}
      >
      {tabs.map((tab) => {
        const isActive = selectedTab.includes(tab.key);
        const isHovered = hoveredKey === tab.key;
        return (
          <button
            key={tab.key}
            role="tab"
            aria-selected={isActive}
            onClick={() => {
              const updated = isActive
                ? selectedTab.filter((k) => k !== tab.key)
                : [...selectedTab, tab.key];
              onTabChange?.(updated, tab);
            }}
            onMouseEnter={() => setHoveredKey(tab.key)}
            onMouseLeave={() => setHoveredKey(null)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "10px 16px",
              borderRadius: "8px",
              border: `1px solid ${isActive || isHovered ? "#2563eb" : "#d1d5db"}`,
              backgroundColor: isActive ? "#2563eb" : "#ffffff",
              color: isActive ? "#ffffff" : isHovered ? "#2563eb" : "#9ca3af",
              fontSize: "13px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              flexShrink: 0,
              cursor: "pointer",
              transition: "all 0.15s ease",
              outline: "none",
              lineHeight: "1.4",
            }}
          >
            {tab.label}

            {showCount && tab.count !== undefined && (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "18px",
                  height: "18px",
                  padding: "0 4px",
                  borderRadius: "9999px",
                  fontSize: "11px",
                  fontWeight: 600,
                  lineHeight: 1,
                  backgroundColor: isActive
                    ? "#FFFFFF40"
                    : "#f3f4f6",
                  color: isActive ? "#ffffff" : "#6b7280",
                }}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
      </div>
     <Button
              size="small"
              variant="contained"
              // onClick={handleClearFilter}
                      onClick={() => onClearAll?.()}
              sx={{ borderRadius: "6px", fontSize: "0.8rem", textTransform: "none", px: 2, height: 30 }}
            >
              Clear All
            </Button>
    </div>
  );
};

CategoryTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
    })
  ).isRequired,
  selectedTab: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  onTabChange: PropTypes.func,
  onClearAll: PropTypes.func,
  showCount: PropTypes.bool,
  className: PropTypes.string,
};
export default CategoryTabs;
